<template>
  <div>
    <v-card class="mx-auto ml-5 my-5 mx-5 mr-5" outlined>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr class="orange darken-1">
              <th colspan="10" class="text-center">
                <span class="white--text text-h6"
                  >WORKSHOP DATA BASE UPDATION</span
                >
              </th>
            </tr>
            <tr>
              <th class="text-left">ENGINEER</th>
              <th class="text-left">TOTAL</th>
              <th class="text-left">COMPLETED</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(record, m) in chartData.records" :key="m">
              <td>{{ record.name }}</td>
              <td>{{ record.totalCustomers }}</td>
              <td>{{ record.totalCustomerscompletedstatus }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>

    <v-card class="mx-auto ml-5 my-5 mx-5 mr-5 " outlined>
      <highcharts :options="chartOptions" ref="highcharts"></highcharts>
      <!--<button @click="updateCredits">update credits</button>-->
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src

import { mapGetters, mapActions } from "vuex";
import { VUE_APP_BASEURL } from "../utils/api";
import axios from "axios";
import store from "../store";

export default {
  name: "WorkshopDataUpdation",
  props: ["selectedsegment", "selectedsalesengineer", "selectedregion"],
  data: () => ({
    chartOptions: {
      chart: {
        type: "column"
      },
      title: {
        text: "WORKSHOP DATA BASE UPDATION"
      },
      subtitle: {
        text: ""
      },
      xAxis: {
        categories: [],
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: ""
        }
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f} </b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      series: [{}],
      credits: {
        enabled: false
      }
    }
  }),
  components: {},
  computed: {
    ...mapGetters(["getWorkshopupdationreportchartdata"]),
    chartData: function() {
      //console.log(this.getWorkshopupdationreportchartdata);
      return this.getWorkshopupdationreportchartdata;
    }
  },
  mounted() {
    /*  setTimeout(() => {
        this.chartOptions.series=this.chartData.customerbarchartData;
        this.chartOptions.xAxis.categories=this.chartData.customerbarchartnames;
        //console.log('updated');
        }, 4000)*/
  },
  created() {
    const filterData = [];
    this.workshopdatabaseupdationreportchart(filterData);

    this.workshopchartload(this.chartOptions);
  },
  methods: {
    ...mapActions(["workshopdatabaseupdationreportchart"]),
    workshopchartload(chartOptions) {
      const filterData = [];

      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "dashboard/workshop-updation-chart",
        data: {
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          region: filterData.region
        }
      })
        .then(function(response) {
          //chartOptions.series[0].data=response.data.response.monthlySalesplanpiechartData;

          chartOptions.series = response.data.response.customerbarchartData;
          chartOptions.xAxis.categories =
            response.data.response.customerbarchartnames;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    filterWorkshopUpdationChart() {
      const filterData = {
        segment: this.selectedsegment,
        salesengineer: this.selectedsalesengineer,
        region: this.selectedregion
      };

      const chartOptions = this.chartOptions;

      axios({
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.getters.UserToken
        },
        url: VUE_APP_BASEURL + "dashboard/workshop-updation-chart",
        data: {
          segment: filterData.segment,
          salesengineer: filterData.salesengineer,
          region: filterData.region
        }
      })
        .then(function(response) {
          //chartOptions.series[0].data=response.data.response.monthlySalesplanpiechartData;

          chartOptions.series = response.data.response.customerbarchartData;
          chartOptions.xAxis.categories =
            response.data.response.customerbarchartnames;
        })
        .catch(function(error) {
          console.log(error);
        });

      this.workshopdatabaseupdationreportchart(filterData);
    }
  }
};
</script>
